import React from 'react'
import "./Services.css";

const Services = () => {
  return (
    <>
      <h2 className="title-s" id="services">
        Servicios
      </h2>
      <article className="row content-value-list">
        <ul className="row content-list">
          <li className="row">
            <div className="row content-animation">
              <h4 className="subtitle-s">
                1. Gerenciamiento y dirección de proyectos de arquitectura
              </h4>
              <h5 className="text-s">
                Anteproyecto, proyecto y diseño arquitectónico. Supervisión de
                la obra, coordinación de equipos, contralor de plazos del
                proyecto, control del presupuesto, intermediación entre
                subcontratos y cumplimiento de las etapas del proyecto de
                arquitectura. Permisos ante los organismos pertinentes para la
                ejecución de la Obra
              </h5>
            </div>
          </li>
          <li className="row">
            <div className="row content-animation">
              <h4 className="subtitle-s">
                2. Obra, Remodelación y Mantenimiento edilicio
              </h4>
              <h5 className="text-s">
                Obra llave en mano, ejecución de proyectos de construcción,
                sanitaria, eléctrica, sistemas de calefacción. Acondicionamiento
                de espacios públicos y privados. Baño, cocina, oficinas,
                revestimiento en yeso, iluminación en ambientes, cambio de
                aberturas, ampliaciones de espacios, optimización de espacios
                pequeños, arreglos de humedades, cielorrasos, pintura,
                impermeabilización de azoteas, cambios de membrana.
              </h5>
            </div>
          </li>
          <li className="row">
            <div className="row content-animation">
              <h4 className="subtitle-s">3. Habilitaciones</h4>
              <h5 className="text-s">
                Ante la Dirección Nacional de Bomberos Ante las Intendencias
                Municipales (comercial, cartelería, viabilidad de uso, etc.)
              </h5>
            </div>
          </li>
          <li className="row">
            <div className="row content-animation">
              <h4 className="subtitle-s">
                4. Auditoría de sistema de protección contra incendio
              </h4>
              <h5 className="text-s">
                Inspección de sistema de detección y extinción de incendios y
                asesoramiento técnico para el cumplimiento a la normativa
                vigente.
              </h5>
            </div>
          </li>
          <li className="row">
            <div className="row content-animation">
              <h4 className="subtitle-s">
                5. Proyecto y/o ejecución de hidráulica de edificios
              </h4>
              <h5 className="text-s">
                Diseño y/o ejecución del proyecto de hidráulica requerido para
                la habilitación ante la Dirección Nacional de Bomberos.
              </h5>
            </div>
          </li>
          <li className="row">
            <div className="row content-animation">
              <h4 className="subtitle-s">6. Caracterización urbana</h4>
              <h5 className="text-s">
                Realización de la declaración jurada ante la Dirección Nacional
                de Catastro que da cuenta de las edificaciones existentes en un
                padrón. Documento con valor legal que certifica el valor
                catastral de un inmueble.
              </h5>
            </div>
          </li>
          <li className="row">
            <div className="row content-animation">
              <h4 className="subtitle-s">
                7. Planes directores de protección y seguridad Industrial
              </h4>
              <h5 className="text-s">
                Planificación de gastos e inversiones en seguridad para los
                activos de empresas e instituciones (edificios, plantas
                industriales, almacenes, etc.). Informes de estado edilicio y de
                las necesidades en base a la normativa aplicable.
              </h5>
            </div>
          </li>
          <li className="row">
            <div className="row content-animation">
              <h4 className="subtitle-s">8. Interiorismo</h4>
              <h5 className="text-s">
                Diseño de espacios interiores armónicos, con adecuada
                colorimetría e iluminación. Selección de materiales adecuados
                para un mejor aprovechamiento del espacio interior.
              </h5>
            </div>
          </li>
          <li className="row">
            <div className="row content-animation">
              <h4 className="subtitle-s">
                9. Green building (Construcción sustentable)
              </h4>
              <h5 className="text-s">
                Planificación, diseño, costo, dirección de obra, permisos de
                construcción y ejecución de obra en materiales alternativos de
                construcción: Steel Framing, Isopanel, Isodec, Madera,
                Concrespuma.
              </h5>
            </div>
          </li>
          <li className="row">
            <div className="row content-animation">
              <h4 className="subtitle-s">
                10. Registro de Sistema de Construcción no tradicionales – CIR
                (Ministerio de Vivienda)
              </h4>
              <h5 className="text-s">
                Diseño del reglamento para Registro de Sistemas Constructivos No
                Tradicionales por Declaración Jurada.
              </h5>
            </div>
          </li>
        </ul>
      </article>
    </>
  );
}

export default Services